import styled from "styled-components";
import dayjs from "dayjs";
import { TimePicker as AntTimePicker } from "antd";
import { RATypography } from "../Typography";
import { useSelector } from "react-redux";
import { isFormatTime12H } from "@/stores/slices/authSlice";
import { noop } from "lodash";

const TIME_PICKER_FORMAT = "HH:mm";
const TIME_PICKER_FORMAT_12H = "hh:mm A";

export const RATimePicker = ({
	title,
	value,
	onChange = noop,
	prefix,
	showNow = false,
	hourStep = 1,
	minuteStep = 5,
	placeholder = "Select time",
	error,
	disabled = false,
	dropdownAlign = null,
	"data-testid": dataTestId = null,
}) => {
	const isTime12H = useSelector(isFormatTime12H);
	return (
		<WrapperTimePicker>
			{title && (
				<WrapperTitle>
					<RATypography color="#595959" variant="sub-heading4">
						{title}
					</RATypography>
				</WrapperTitle>
			)}
			<StyledTimePicker
				showNow={showNow}
				size="large"
				value={value ? dayjs(value) : null}
				onSelect={(e) => onChange(e.toISOString())}
				placeholder={placeholder}
				hourStep={hourStep}
				minuteStep={minuteStep}
				disabled={disabled}
				dropdownAlign={dropdownAlign}
				inputReadOnly
				allowClear={false}
				format={!isTime12H ? TIME_PICKER_FORMAT : TIME_PICKER_FORMAT_12H}
				suffixIcon={prefix}
				panelRender={(originPanel) => <PanelWrapper>{originPanel}</PanelWrapper>}
				data-testid={dataTestId}
			/>
			{!!error && (
				<RATypography variant="body3" color="#BF1A2F" top="4px">
					{error}
				</RATypography>
			)}
		</WrapperTimePicker>
	);
};

const StyledTimePicker = styled(AntTimePicker)`
	width: 100%;
	border-radius: 12px;
	padding-left: 20px;
	padding-right: 8px;
	height: 44px;
	&.ant-picker-large {
		height: 52px;
	}
	&.ant-picker-small {
		height: 40px;
		border-radius: 8px;
		padding-left: 16px;
		padding-right: 4px;
	}
	@media (max-width: 576px) {
		padding-left: 10px;
	}
`;
const WrapperTimePicker = styled.div`
	.ant-picker {
		border-color: #e9e8e8;
		&:hover {
			border-color: #ffb11a !important;
		}
	}
	.ant-picker-dropdown
		.ant-picker-time-panel-column
		> li.ant-picker-time-panel-cell
		.ant-picker-time-panel-cell-inner:hover {
		background: #ffb11a;
	}
	.ant-picker-focused {
		border-color: #ffb11a !important;
	}
	.ant-picker .ant-picker-input {
		gap: 6px;
		@media (max-width: 576px) {
			gap: 0px;
		}
	}
	.ant-picker .ant-picker-input span.ant-picker-suffix,
	.ant-picker.ant-picker-range span.ant-picker-suffix {
		margin-left: 1px;
		margin-right: 6px;
		order: -1;
	}
	.ant-picker-large .ant-picker-input > input {
		font-size: 14px;
		letter-spacing: 0.5px;
	}
`;
const WrapperTitle = styled.div`
	padding-bottom: 8px;
`;
const PanelWrapper = styled.div`
	.ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner {
		width: 100%;
		height: 36px;
		color: #222222;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-inline-start: 0;
	}
	.ant-picker-time-panel-column > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {
		background: #ffb11a;
	}
	.ant-picker-time-panel-column {
		width: 75px;
	}
	.ant-picker-ranges .ant-picker-ok {
		margin-inline-start: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}
	.ant-picker-ranges .ant-picker-ok button {
		height: 36px;
		padding: 0px 26px;
		border-radius: 32px;
		background-color: transparent;
		color: #222222;
		border: 1px solid #e9e8e8;
		font-size: 14px;
	}
	.ant-picker-time-panel-column::after {
		height: 0;
	}
	.ant-picker-time-panel-column::-webkit-scrollbar {
		width: 4px;
	}
	.ant-picker-time-panel-column::-webkit-scrollbar-thumb {
		border-radius: 8px;
		background: #ededed;
	}
`;
